module.exports = __webpack_public_path__ + "img/icon_clip.7a6db0f5.svg";